import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { SpaceVulnerabilityPage } from "~/pages/space/vulnerabilities/SpaceVulnerability";

interface SoftwareEntryPageProps {
  space: Space;
  scope: SpaceOrWorkspaceScope;
}

const SoftwareEntryPage = ({ space, scope }: SoftwareEntryPageProps) => {
  return <SpaceVulnerabilityPage space={space} scope={scope} />;
};

export default SoftwareEntryPage;
